<template>
  <div class="zcfg_list">
    <div class="banner">
      <img src="../../../static/icon/zcfgBanner.png" alt="">
      <div class="info">
<!--        <p class="title_info">智慧供热服务大厅</p>-->
      </div>
    </div>
    <mt-cell class="mint-cell-mask" v-for="(item) in zcfgList"  icon="more" :key="item.id" :title="item.title"  is-link :to="{path:'/zcfgneirong',query:{zcfgcontent:item.content}}">
      <img slot="icon" src="../../../static/icon/bszn.png" width="24" height="24">
    </mt-cell>
  </div>
</template>

<script>
import {wechatZcfg} from "@/api";
import {getQueryVariable} from "@/utils";

export default {
  name: "banshizhinan",
  data (){
    return {
      zcfgList:[],
      type:'bszn',
      companyCode:sessionStorage.getItem("companyCode"),
    }
  },
  created(){
    this.getList()
  },
  methods:{
    getList(){
      const companyCode = sessionStorage.getItem('companyCode')?sessionStorage.getItem('companyCode'):getQueryVariable("state")
      wechatZcfg(companyCode,this.type).then(res => {
        this.zcfgList = res.data
      })
    },
  }
}
</script>

<style type="text/css" scoped>
.zcfg_list{
  min-height: 90%;
}
.right_jiantou {
  font-size: 25px;
  clear: both;
  vertical-align: middle;
}
.mint-cell-mask{
  border-bottom: 1px #f5f5f5 solid;
}
.banner {
  text-align: center;
  position: relative;
}

.banner img {
  width: 100%;
  height: auto;
}
.info{
  position: absolute;
  top: 33%;
  left: 5%;
  color: #f1f1f1;
  text-align: left;
}
.info>.title_info{
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 14px;
}
.info>.text_info{
  font-size: 16px;
}
</style>




// WEBPACK FOOTER //
// src/view/xxcx/banshizhinan.vue